module.exports = __webpack_public_path__ + "img/logo-inline.8fce0460.png";